import { FormValidateRule } from '../../form/type/form-item';

export interface OptionProps {
  symbol: string;
  label: string;
  value: boolean;
  visible?: boolean;
}

export enum FormType {
  INPUT = 'input',
  CHECKBOX = 'checkbox',
  FILE = 'file',
  RADIO = 'radio',
  SELECT = 'select',
  TEXTAREA = 'textarea',
}
export interface FieldProps {
  type: FormType;
  label?: string;
  name: string;
  className?: string;
  inputClassName?: string;
  required?: boolean;
  maxLength?: number;
  placeHolder?: string;
  onChange?: any;
  tip?: string | string[];
  prefix?: string;
  prompt?: string;
  rules?: FormValidateRule[];
  options?: OptionProps[];
  subfix?: string;
  buttonText?: string;
  defaultItemCount?: number;
  showOrder?: boolean;
  showColumnHeader?: boolean;
  group?: string;
  defaultValue?: string | any[];
  disabled?: boolean;
  isImgFile?: boolean;
}
